<template>
  <section>
    <aRow>
      <aCol
        class="collapse-card"
        v-for="{ id } in thirdPartyRows"
        :key="id"
        :span="24"
      >
        <div class="head" @click="onClickOpenCollapse(id)">
          <aRow :gutter="20">
            <aCol class="id cprimary" :span="1">
              <span class="ico">
                <aIcon type="user" />
                <span class="num">{{ id }} </span>
              </span>
            </aCol>

            <aCol class="id-name" :span="11">
              TERCEIRO ({{
                tempContract[
                  `third_party_client_first_name_${id}${keySuffix}`
                ] ?? "NOME"
              }})
            </aCol>

            <aCol class="value" :span="9">
              <aTag :color="'blue'">
                {{
                  tempContract[
                    `third_party_client_paid_value_${id}${keySuffix}`
                  ] | formatPricePtBrComma
                }}
              </aTag>
            </aCol>

            <aCol class="a-right" :span="3">
              <aButton
                class="ml-5"
                v-if="id > 1 && thirdPartyRows.length === id"
                size="small"
                type="danger"
                shape="circle"
                icon="delete"
                @click="removeRow(id - 1)"
                ghost
              >
              </aButton>
            </aCol>
          </aRow>
        </div>

        <div class="content" v-if="openCollapse === id">
          <ThirdPartyCollapse
            :form="form"
            :bankTransferId="id"
            :tempContract="tempContract"
            :keyPrefix="keyPrefix"
            :keySuffix="keySuffix"
            :clientId="id"
            :reservation_total_price="reservation_total_price"
            @updateTotalThirdPartyValue="updateTotalThirdPartyValue"
          />
        </div>
      </aCol>
    </aRow>

    <div class="a-center mb-40 mt-20">
      <aButton type="primary" @click="addNewRow(thirdPartyRows.length)" ghost>
        Adicionar terceiro
      </aButton>

      <aFormItem class="none">
        <aInput v-decorator="[`third_party_payment_rows${keySuffix}`]" />
      </aFormItem>
    </div>
  </section>
</template>

<script>
import formatThings from "@/mixins/general/formatThings.js";
import ThirdPartyCollapse from "../collapses/ThirdPartyCollapse.vue";

export default {
  name: "ThirdPartyTabModal",
  props: {
    tempContract: Object,
    form: Object,
    keyPrefix: String,
    keySuffix: String,
    reservation_total_price: Number,
  },
  components: { ThirdPartyCollapse },
  mixins: [formatThings],
  data() {
    return {
      openCollapse: "",
      thirdPartyRows: [],
    };
  },
  mounted() {
    if (
      this.tempContract[`third_party_payment_rows${this.keySuffix}`] !==
      undefined
    ) {
      this.thirdPartyRows = JSON.parse(
        this.tempContract[`third_party_payment_rows${this.keySuffix}`]
      );
    }

    this.form.setFieldsValue({
      [`third_party_payment_rows${this.keySuffix}`]: JSON.stringify(
        this.thirdPartyRows
      ),
    });
  },
  methods: {
    updateTotalThirdPartyValue() {
      this.$emit("updateTotalValue");
    },
    onClickOpenCollapse(id) {
      if (id == this.openCollapse) {
        this.openCollapse = 0;
      } else {
        this.openCollapse = id;
      }
    },
    addNewRow(id) {
      this.thirdPartyRows.push({
        id: id + 1,
      });

      this.tempContract[`third_party_payment_rows${this.keySuffix}`] =
        JSON.stringify(this.thirdPartyRows);

      this.form.setFieldsValue({
        [`third_party_payment_rows${this.keySuffix}`]: JSON.stringify(
          this.thirdPartyRows
        ),
      });

      this.$emit("updateTotalValue");
    },
    removeRow(index) {
      for (var i in this.thirdPartyRows) {
        if (i == index) {
          this.thirdPartyRows.splice(i, 1);
          break;
        }
      }

      this.tempContract[`third_party_payment_rows${this.keySuffix}`] =
        JSON.stringify(this.thirdPartyRows);

      this.form.setFieldsValue({
        [`third_party_payment_rows${this.keySuffix}`]: JSON.stringify(
          this.thirdPartyRows
        ),
      });
      this.$emit("updateTotalValue");
    },
  },
};
</script>

<style lang="sass" scoped>
.collapse-card
  .content
    padding: 30px 20px 20px
    border: 1px solid #ccc
    margin-top: -14px
    border-radius: 0 0 6px 6px
    margin-bottom: 11px
    background: #fff
  .head
    cursor: pointer
    clear: both
    padding:  20px
    background: #fff
    border: 1px solid #ccc
    margin-bottom: 10px
    border-radius: 6px
    .id
      color: #474747
      font-weight: 600
      .ico
        position: relative
        font-size: 14px
      .num
        position: absolute
        right: -13px
        top: 0
        font-size: 11px
        color: #333
    .id-name
      padding-left: 20px !important
      color: #42413f
      font-weight: 500
      text-transform: uppercase
    .value
      font-size: 10px
      color: #42413f
      font-weight: 500
      text-transform: uppercase
</style>
